<script lang="ts">
    export let isAnimated = false;
    export let lottieJson: any = null;
    export let svg = '';
    export let platform = '';
    export let iconName = '';
    export let icon = 'adb';
    export let color = '#0A0A0A';
    export let decodeSVG: () => string;
</script>

{#if isAnimated}
    {#if !lottieJson}
        {@html decodeSVG()}
    {:else}
        <lottie-player src={lottieJson} loop autoplay />
    {/if}
{:else if svg || (platform && iconName)}
    {@html decodeSVG()}
{:else}
    <!-- Legacy Icon -->
    <div class="fun-text-center"><i class="icon" style="color: {color}">{icon}</i></div>
{/if}

<style lang="scss">
    .icon {
        font-family: 'Material Icons';
        font-weight: normal;
        font-style: normal;
        display: inline-block;
        line-height: 1;
        text-transform: none;
        letter-spacing: normal;
        word-wrap: normal;
        white-space: nowrap;
        direction: ltr;
        font-feature-settings: 'liga';
        font-size: 32px;
    }
</style>
